import React, { type FC } from 'react';

import Column from '@amzn/meridian/column';
import Link from '@amzn/meridian/link';
import Row from '@amzn/meridian/row';
import Tag from '@amzn/meridian/tag';
import Text from '@amzn/meridian/text';
import moment from 'moment';
import EmDash from 'src/components/shared/emdash';
import { getTzShort } from 'src/utils/dateUtils';

interface RestrictionHeaderProps {
  taskName: string;
  accommodationId: number;
  accommodationType: string;
  externalCaseId: string;
  updatedAt: string;
  updatedBy: string;
  isNonPhysical?: boolean;
}

const RestrictionHeader: FC<RestrictionHeaderProps> = ({
  taskName,
  accommodationId,
  accommodationType,
  externalCaseId,
  updatedAt,
  updatedBy,
  isNonPhysical = false,
}) => (
  <Column spacing="none" spacingInset="none">
    <Row spacing="400">
      <Text type="h100">{taskName}</Text>
      <Tag type={isNonPhysical ? 'neutral' : 'theme'}>{isNonPhysical ? 'Non-Physical' : 'Physical'}</Tag>
    </Row>
    <Row spacing="300">
      <Link type="secondary" href={`/placementDetails/${accommodationId}`}>
        {accommodationType} | {externalCaseId ?? <EmDash />}
      </Link>
      <Text color="secondary">•</Text>
      <Text color="secondary">
        Last Updated: {moment(updatedAt).format('L [at] h:mma')} {getTzShort()}
      </Text>
      <Text color="secondary">•</Text>
      <Link href={`https://phonetool.amazon.com/users/${updatedBy}`} target="_blank" rel="noopener noreferrer">
        {updatedBy}@
      </Link>
    </Row>
  </Column>
);

export default RestrictionHeader;
